@let medication = this.medication();
@let displayLabel = label();

<p-popover #op>
    <div class="contentGrid">
        <div class="text-right">{{ 'medications.code' | translate }}</div>
        <div>{{ medication?.code }}</div>

        <div class="text-right">{{ 'medications.registeredName' | translate }}</div>
        <div>{{ medication?.registeredName }}</div>

        <div class="text-right">{{ 'medications.name' | translate }}</div>
        <div>{{ medication?.name }}</div>

        @if (medication?.nameAddition) {
            <div class="text-right">{{ 'medications.nameAddition' | translate }}</div>
            <div>{{ medication?.nameAddition }}</div>
        }
        @if (medication?.strength) {
            <div class="text-right">{{ 'medications.strength' | translate }}</div>
            <div>{{ medication?.strength }}</div>
        }
        @if (medication?.form) {
            <div class="text-right">{{ 'medications.form' | translate }}</div>
            <div>{{ medication?.form }}</div>
        }
        @if (medication?.packaging) {
            <div class="text-right">{{ 'medications.packaging' | translate }}</div>
            <div>{{ medication?.packaging }}</div>
        }
        @if (medication?.administration) {
            <div class="text-right">{{ 'medications.administration' | translate }}</div>
            <div>{{ medication?.administration }}</div>
        }
        @if (medication?.packageLanguage) {
            <div class="text-right">{{ 'medications.packageLanguage' | translate }}</div>
            <div>{{ medication?.packageLanguage }}</div>
        }
        @if (medication?.packageType) {
            <div class="text-right">{{ 'medications.packageType' | translate }}</div>
            <div>{{ medication?.packageType }}</div>
        }
        @if (medication?.regime) {
            <div class="text-right">{{ 'medications.regime' | translate }}</div>
            <div>{{ medication?.regime }}</div>
        }
        @if (medication?.substances) {
            <div class="text-right">{{ 'medications.substances' | translate }}</div>
            <div>{{ medication?.substances }}</div>
        }
        @if (medication?.addiction) {
            <div class="text-right">{{ 'medications.addiction' | translate }}</div>
            <div>{{ medication?.addiction }}</div>
        }
        @if (medication?.gov) {
            <div class="text-right">{{ 'medications.gov' | translate }}</div>
            <div>{{ medication?.gov }}</div>
        }
        @if (medication?.atc) {
            <div class="text-right">{{ 'medications.atc' | translate }}</div>
            <div>{{ medication?.atc }}</div>
        }
        @if (medication?.atcName) {
            <div class="text-right">{{ 'medications.atcName' | translate }}</div>
            <div>{{ medication?.atcName }}</div>
        }

        <div></div>
        <div></div>

        @if (medication?.spcPdfUrl) {
            <div class="text-right">{{ 'medications.spcPdf' | translate }}</div>
            <a href="{{ medication?.spcPdfUrl}}" download>{{ medication?.spcPdf }}</a>
        }
        @if (medication?.pilPdfUrl) {
            <div class="text-right">{{ 'medications.pilPdf' | translate }}</div>
            <a href="{{ medication?.pilPdfUrl }}" download>{{ medication?.pilPdf }}</a>
        }
        @if (medication?.packageTextPdfUrl) {
            <div class="text-right">{{ 'medications.packageTextPdf' | translate }}</div>
            <a href="{{ medication?.packageTextPdfUrl }}" download>{{ medication?.packageTextPdf }}</a>
        }
    </div>
</p-popover>

@if (displayLabel !== undefined) {
    <app-link-button
        (clickEvent)="op.toggle($event)"
        [label]="displayLabel"
        [disabled]="isOffline()"
    ></app-link-button>
} @else {
    <p-skeleton></p-skeleton>
}
